<template>
  <div>
      <v-container fluid class="white elevation-3 margen d-flex justify-space-around">
      <v-row class="pb-3 d-flex justify-space-around">
        <v-col cols="12" sm="12" md="3" class="ma-auto">
          <h1>Reportes</h1>
        </v-col>
        <v-col>

        </v-col>
        <!-- <v-col cols="12" sm="12" md="3" class="ma-auto mb-n6"> -->
          <!-- <v-text-field dense outlined label="Buscar Maquinado" v-model="buscador" class="mx-2"/> -->
        <!-- </v-col> -->
      </v-row>
      <!-- 
          copiar esto
          <v-col cols="12" sm="12" md="3" class="ma-auto">
          <a :href="'//'+rutaArchivo" target="_blank" download>Reporte ordenes de compras</a>
        </v-col>
       -->
    </v-container>
    <div class="mt-3">
        <v-card class="px-1">
          <v-card-title class="d-flex justify-center text-h4 font-weight-medium"> Reporte órdenes de Compra </v-card-title>
          
            <!-- <div class="d-flex justify-space-around">
                <v-card-title> Órdenes de compra </v-card-title> 
                <v-card-title class="text-body-1 paddingTextoCarta overflow" >
                </v-card-title>
            </div> -->
            <!-- <div class="d-flex justify-space-around">
                <v-card-title> Folio </v-card-title> <v-card-title class="text-body-1">{{proyecto.FOLIO}}</v-card-title>
            </div> -->

            <!-- <v-spacer class="my-1"></v-spacer> -->

            <v-card-actions class="d-flex justify-center">
                <v-btn icon @click="mostrar = !mostrar">
                    <v-icon> {{ mostrar ? "mdi-chevron-up" : "mdi-chevron-down" }} </v-icon>
                </v-btn>
            </v-card-actions>

            <v-expand-transition>
                <div v-show="mostrar" class="text-center">
                    <!-- <v-divider></v-divider> -->

                    <!-- <v-col cols="4" class="d-flex justify-space-around"> -->
                    <!-- <v-row class="ma-0"> -->
                        <!-- <v-col cols="12" sm="6" md="6" class="d-flex justify-space-around pa-0"> -->

                          <v-card-subtitle>Filtrar reporte por:</v-card-subtitle>
                

                <v-card-actions class="d-flex justify-center">
                <v-row>
                <v-col cols="12" sm="12" md="3" class="py-0">
                  <v-autocomplete
                    label="Proveedor (opcional)"
                    filled
                    dense
                    v-model="proveedorSeleccionado"
                    :items="proveedores"
                    item-text="NOMBRE"
                    item-value="NOMBRE"
                    return-object
                  ></v-autocomplete>
                </v-col>

                <v-col cols="12" sm="12" md="3" class="py-0">
                  <v-autocomplete
                    label="Vendedor (opcional)"
                    filled
                    dense
                    v-model="vendedorSeleccionado"
                    :items="vendedores"
                    item-text="NOMBRE"
                    item-value="NOMBRE"
                    return-object
                  ></v-autocomplete>
                </v-col>
              
                <v-col cols="12" sm="12" md="3" class="py-0">
                  <v-menu
                    v-model="modalFechaInicio"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                  
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        filled
                        dense
                        light
                        v-model="fechaInicioSeleccionada"
                        label="Fecha Inicio (opcional)"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      >
                      </v-text-field>
                    </template>
                    
                  <v-date-picker
                    v-model="fechaInicioSeleccionada"
                    @input="modalFecha = false"
                    :min="minFecha[0]"
                  >
                  </v-date-picker>
                </v-menu>
                  </v-col>

                  <v-col cols="12" sm="12" md="3" class="py-0">
                  <v-menu
                    v-model="modalFechaFin"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        filled
                        dense
                        light
                        v-model="fechaFinSeleccionada"
                        label="Fecha Final (opcional)"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      >
                      </v-text-field>
                    </template>
                  <v-date-picker
                    v-model="fechaFinSeleccionada"
                    @input="modalFecha = false"
                    :min="minFecha[0]"
                  >
                  </v-date-picker>
                  </v-menu>
                  </v-col>
            
                </v-row>
                </v-card-actions>
               
                <!-- <v-btn large class="primary darken-1 ma-3" @click="descargarExcel()" :href="'//'+rutaArchivo" target="_blank" download>
                                Descargar Reporte
                </v-btn> -->
                <v-btn large class="primary darken-1 ma-3" @click="descargarExcel()" target="_blank">
                                Descargar Reporte
                </v-btn>
                </div>
                
            </v-expand-transition>
        </v-card>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
export default {
    data() {
    return {
        rutaArchivo: "",
        mostrar:false,

        //datos para enviar
        proveedorSeleccionado: null,
        vendedorSeleccionado: null, 
        fechaInicioSeleccionada: null,
        fechaFinSeleccionada: null,

        //Datos para validar la información 
        proveedores:[],
        vendedores:[],
        modalFecha: false,
        modalFechaInicio: false,
        modalFechaFin: false,
        minFecha: ""
    };
  },
    computed: {
    ...mapGetters([
      'getURLAPI',
      'getRolesUsuario',
      'getUsuario',
      ]),
  },
  methods: {
      descargarExcel(){
        //console.log("entro Descargar Excel");
        let datosForm = new FormData();
      
        if ( this.proveedorSeleccionado != null)
        {
          if(this.proveedorSeleccionado.PROVEEDOR_ID != "")
          {
            //console.log("Selecciono proveedor:"+this.proveedorSeleccionado.PROVEEDOR_ID);
            datosForm.append("PROVEEDOR_ID",          this.proveedorSeleccionado.PROVEEDOR_ID);
          }
        }

        if(this.vendedorSeleccionado != null)
        {
          if(this.vendedorSeleccionado.USUARIO != "")
          {
            //console.log("Selecciono VENDEDOR:"+this.vendedorSeleccionado.USUARIO);
            datosForm.append("USUARIO",         this.vendedorSeleccionado.USUARIO);
          }
        }
        
        
        if((this.fechaInicioSeleccionada != null && this.fechaInicioSeleccionada != "")  &&  (this.fechaFinSeleccionada != null && this.fechaFinSeleccionada != "") )
        {
          if(this.fechaInicioSeleccionada <= this.fechaFinSeleccionada)
          {
            //console.log("FECHA INICIO:"+this.fechaInicioSeleccionada);
            //console.log("FECHA FIN:"+this.fechaFinSeleccionada);
            datosForm.append("FECHA_INICIO",  this.fechaInicioSeleccionada);
            datosForm.append("FECHA_FIN",     this.fechaFinSeleccionada);
            //console.log("Console fecha inicio ".);
          }
          else
          {
            this.$root.vtoast.show(
                { message: "Selecciona un periodo de fechas correctas",  color:'black', })
          }
        }
        //se mandan los datos para crear la liga a descargar excel
        //this.rutaArchivo = (await axios.get(`${this.getURLAPI}/Ordenes/descargarReporte`)).data
        axios.post(`${this.getURLAPI}/Ordenes/descargarReporte`, datosForm, {
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then(({ data }) => {
            console.log(data);
            this.rutaArchivo = data;
            window.open("https://"+data);
            // Cambiar el foco al nuevo tab (punto opcional)
            //win.focus();
          })
          
      },
      // ------------------------------------------------------------------------------
      async getProveedores()
      {
        this.proveedores = (await axios.get(`${this.getURLAPI}/Show/allProveedores`)).data
     
      },
      // ------------------------------------------------------------------------------
      async getVendedores()
      {
        this.vendedores = (await axios.get(`${this.getURLAPI}/Show/allVendedor`)).data
      },
  },
 
  created() {
  this.getProveedores();
  this.getVendedores();
  //this.descargarExcel();
  //this.minFecha = this.fecha.split(" ");
  },
};
</script>

<style>

</style>